<script>
import Layout from "../Layout.vue";
import {get} from "@/utils/api";
import SiteLabel from "@/components/commons/SiteLabel.vue";
import Btn from "@/components/commons/SmartBtn.vue";
import {EventBus} from "@/components/commons/event-bus";

export default {
  name: "TypebotSubmissions",
  components: {Btn, SiteLabel, Layout},
  data() {
    return {

      selectedRows: [],

      selectedBot: null,
      bots: [
        {id: 'cmpzk2a2800000bjh5azx1ga6', name: 'Devis groupe'},
        {id: 'o5d2n78jut1gr5j8vxwflizo', name: 'Travel Pref'},
        //{id: 'cmq97m33l00010bkqfvt0rixe', name: 'Hotel finder'} //, not yet visible
      ],

      loading: false,
      headers: [],
      rowsPerPageItems: [{text: "Tous", value: -1}, 50, 200],
      items: [],

      sites: {
        'hotel-zil-maurice.re': 'ZilMaurice',
        'hotelissima.fr': 'Hotelissima'
      }
    }
  },
  async created() {
    this.selectedBot = this.bots[0].id
    await this.init()
  },

  methods: {
    async init() {
      this.loading = true
      await this.get()
      this.loading = !this.loading

    },
    async get() {

      if (this.selectedBot == null) return;

      this.selectedRows = []

      const submissions = await this.getSubmissions()
      this.headers = this.buildHeaders(submissions)
      this.items = this.buildRows(submissions)

      return this.items;
    },
    getSubmissions() {
      return get(`/api/lead/thirdparty/typebot/${this.selectedBot}/get`).json((responses) => {
        return responses
      });
    },
    buildHeaders(submissions) {
      const variables = submissions.flatMap(s => s.variables)

      return [
        ...[
          {text: "creation date", value: "createdAt", align: "left", sortable: false}
        ],

        ...[
          ...new Map(variables.map(v => [v.name, v])).values()].map(v => {
          return {
            text: v.name,
            value: v.name,
            align: "left",
            sortable: false
          }
        }),
        ...[
          {text: "Client", value: "srClientId", align: "left", sortable: false},
          {text: "Lead", value: "srLeadId", align: "left", sortable: false},
        ]
      ]
    },
    buildRows(submissions) {
      return submissions.map(submission => ({
        ...Object.fromEntries(submission.variables.map(v => [v.name, v.value])),
        createdAt: submission.createdAt,
        srClientId: submission.srClientId,
        srLeadId: submission.srLeadId,
        id: submission.id,

      }))
    },
    deleteSelectedRows() {
      if (this.selectedRows.length === 0) return;

      const qs = this.selectedRows.map(sr => {
        return sr.id
      }).join(',')

      return get(`/api/lead/thirdparty/typebot/${this.selectedBot}/delete?resultIds=${qs}`)
      .badRequest(err => {
        EventBus.$emit('toaster-msg', err.toString())
      }).res(() => {
        EventBus.$emit('toaster-msg', "Suppression enregistrée")

        this.selectedRows = []
        this.init()
      });
    }
  },
  computed: {},
}

</script>

<template>
  <layout :drawerShow="true" :drawerWidth="350">
    <template slot="nav-tools">
      <div>
        <v-btn disabled v-if="selectedRows.length>0"
               color="error" depressed small
               class="mr-2" secondary tertiary
               @click="deleteSelectedRows"
        >
          <v-icon small color="white" class="mr-1">mdi-alert-circle</v-icon>

          Supprimer {{ selectedRows.length }}
        </v-btn>
      </div>
    </template>

    <template slot="drawer">
      <v-row>
        <v-col cols="12">
          <v-subheader light class="pa-0 mt-5 mb-0 mx-0 form-subheader"
          >Choix formulaire
          </v-subheader
          >
          <v-divider></v-divider>

          <v-select
              v-model="selectedBot"
              :items="bots"
              item-value="id"
              item-text="name"
              label="Formulaire"
              hide-details
              placeholder=" "
              clearable
          />
        </v-col>
        <v-col cols="12">
          <smart-btn
              :loading="loading"
              @click.native="init"
              block
          >
            Rechercher
          </smart-btn>
        </v-col>
      </v-row>
    </template>
    <template slot="content">
      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <v-data-table
                v-model="selectedRows"
                show-select
                item-key="id"
                :loading="loading"
                :headers="headers"
                :items="items"
                :footer-props="{
                'items-per-page-options': rowsPerPageItems,
                'items-per-page-text': 'Lignes par page',
              }"
                class="tbl"
                no-data-text="0 résultats"
            >

              <template #item.currentSite="{value}">
                <site-label v-if="value" :sitename="sites[value]"/>
                <template v-else>-</template>
              </template>
              <template #item.createdAt="{value}">
                {{
                  _formatDate(
                      _parseDateISO(
                          value),
                      "dd/MM/yyyy HH:mm")
                }}
              </template>
              <template #item.srClientId="{value}">
                <v-btn v-if="value != null"
                       x-small
                       elevation="0"
                       :href="$router.resolve({name: 'customer-edition', params: { id: value }}).href"
                       target="_blank"
                >
                  Voir
                </v-btn>
                <template v-else>-</template>
              </template>
              <template #item.srLeadId="{value}">
                <v-btn v-if="value != null"
                       x-small
                       elevation="0"
                       :href="$router.resolve({name: 'lead', params: { id: value }}).href"
                       target="_blank"
                >
                  Voir
                </v-btn>
                <template v-else>-</template>
              </template>
            </v-data-table>
          </v-col>
        </v-row>

      </v-container>
    </template>
  </layout>
</template>

<style scoped>

</style>